import { LoanSubmissionStep } from '@roc/feature-loans';
import { LoanSubType } from '@roc/feature-utils';

export const loanSubTypeOptions = [
  {
    label: 'Fix & Flip',
    value: LoanSubType.FIX_AND_FLIP,
  },
  {
    label: 'Ground Up',
    value: LoanSubType.GROUND_UP,
  },
  {
    label: 'Single Property Rental',
    value: LoanSubType.SINGLE_PROPERTY,
  },
];

export const borrowerLoanSubmissionSteps = {
  [LoanSubmissionStep.PROPERTY_INFORMATION]: 0,
  [LoanSubmissionStep.ENTITY_INFORMATION]: 1,
  [LoanSubmissionStep.BORROWER_INFORMATION]: 2,
  [LoanSubmissionStep.SUMMARY]: 3,
  [LoanSubmissionStep.SUCCESS]: 4,
};

export enum BorrowerInformationSteps {
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  CO_BORROWER_INFORMATION = 'CO_BORROWER_INFORMATION',
  EDIT_PERSONAL_INFORMATION = 'EDIT_PERSONAL_INFORMATION',
  EDIT_CO_BORROWER_INFORMATION = 'EDIT_CO_BORROWER_INFORMATION',
  ENTITY_OWNERSHIP = 'ENTITY_OWNERSHIP',
  BORROWER_INFORMATION_COMPLETED = 'BORROWER_INFORMATION_COMPLETED',
}
export const PROPERTY_INFORMATION_STEP = {
  TELL_US_ABOUT_YOUR_PROPERTY: {
    subStep: 1,
    labelIndexNumber: 1,
    label: 'Property Information',
    subLabel: 'Tell us about the property.',
  },
  TELL_US_ABOUT_YOUR_RENTAL_HOME: {
    subStep: 2,
    labelIndexNumber: 1,
    label: 'Property Information',
    subLabel: 'Tell us about your rental home purchase.',
  },
};

export const LOAN_ECONOMICS_STEP = {
  CHOOSING_YOUR_LOAN_TERMS: {
    subStep: 1,
    labelIndexNumber: 3,
    label: 'Loan Economics',
    subLabel: 'Choosing your loan terms.',
  },
}
export const QUOTE_SUMMARY_STEP = {
  QUOTE_SUMMARY_STEP: {
    subStep: 1,
    labelIndexNumber: 4,
    label: 'Quote Summary',
    subLabel: '',
  },
}
export const QUOTE_COMPLETE_STEP = {
  QUOTE_COMPLETE_STEP: {
    subStep: 1,
    labelIndexNumber: 5,
    label: 'Complete',
    subLabel: '',
  },
}
export const DEFAULT_FEE_RETAIL_SERVICING_SETUP = 30;
export const DEFAULT_FEE_LEGAL_REVIEW = 995;
export const DEFAULT_FEE_CORELOGIX = 275;
export const INTEREST_RESERVE = 0;
export const SERVICING_SETUP_FEE = 0;
export const BROKWER_ORIGINATION_FEE = 0;
export const THIRD_PARTY_COST = 0;


export enum BorrowerEntityInformationSteps {
  ENTITY_INFORMATION = 'ENTITY_INFORMATION',
  EDIT_OWNERSHIP_INFORMATION = 'EDIT_OWNERSHIP_INFORMATION',
  BORROWER_CITIZENSHIP = 'BORROWER_CITIZENSHIP',
  BORROWER_CREDIT = 'BORROWER_CREDIT',
  SELECT_ENTITY_OPTION = 'SELECT_ENTITY_OPTION',
  SEARCH_ENTITY = 'SEARCH_ENTITY',
  ADD_ENTITY = 'ADD_ENTITY',
  ENTITY_OWNERSHIP = 'ENTITY_OWNERSHIP',
  EDIT_ENTITY_INFORMATION = 'EDIT_ENTITY_INFORMATION',
  BORROWER_INFORMATION = 'BORROWER_INFORMATION',
  ENTITY_INFORMATION_COMPLETED = 'ENTITY_INFORMATION_COMPLETED',
}

export enum PropertyInformationSteps {
  PROPERTY_INFORMATION = 'PROPERTY_INFORMATION',
  EDIT_PROPERTY_INFORMATION = 'EDIT_PROPERTY_INFORMATION',
  PROPERTY_INFORMATION_COMPLETED = 'PROPERTY_INFORMATION_COMPLETED',
}

export const FORM_MAX_WIDTH = '736px';

export enum SelectEntityOption {
  SEARCH_ENTITY = 'SEARCH_ENTITY',
  ADD_ENTITY = 'ADD_ENTITY',
  NO_ENTITY = 'NO_ENTITY',
}
